<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar :color="toolbarColor">
                <v-btn icon @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Application ({{ item.residenceTerm }})</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn text @click="closeDialog()">Close</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-tabs v-model="tab" fixed-tabs :background-color="kingsGreen" dark show-arrows>
                <v-tab>
                    <v-icon left>mdi-numeric-1-circle</v-icon>Personal Information
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-numeric-2-circle</v-icon>Emergency Contact
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-numeric-3-circle</v-icon>Building Preference
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-numeric-4-circle</v-icon>Accommodation Consideration
                </v-tab>
                <v-tab v-if="item.applicantRole == 'residenceAssistant'">
                    <v-icon left>mdi-numeric-5-circle</v-icon>General Information
                </v-tab>
                <v-tab v-else>
                    <v-icon left>mdi-numeric-5-circle</v-icon>Placement Preference
                </v-tab>
                <v-tab v-if="item.hasOwnProperty('rulesOfResidence') && item.rulesOfResidence != ''">
                    <v-icon left>mdi-numeric-6-circle</v-icon>Rules Of Residence
                </v-tab>
                <v-tab>
                    <v-icon left v-if="item.hasOwnProperty('rulesOfResidence') && item.rulesOfResidence != ''">mdi-numeric-7-circle</v-icon>
                    <v-icon left v-else>mdi-numeric-6-circle</v-icon>
                    Residence Agreement
                </v-tab>
                <v-tab>
                    <v-icon left v-if="item.hasOwnProperty('rulesOfResidence') && item.rulesOfResidence != ''">mdi-numeric-8-circle</v-icon>
                    <v-icon left v-else>mdi-numeric-7-circle</v-icon>
                    Payment Method
                </v-tab>
            </v-tabs>
            <v-container fluid>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card flat>
                            <!-- Personal Information -->
                            <application-personal-information :item="item"></application-personal-information>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <!-- Emergency Contact Information -->
                            <application-emergency-contact-information :item="item">
                            </application-emergency-contact-information>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card v-if="item.applicantRole == 'residenceAssistant'" flat>
                            <!-- RA - Building Preference -->
                            <ra-application-building-preference :item="item" :user="user">
                            </ra-application-building-preference>
                        </v-card>
                        <v-card v-else flat>
                            <!-- Building Preference -->
                            <application-building-preference :item="item"></application-building-preference>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <!-- Accommodation Consideration -->
                            <application-accommodation-consideration :item="item">
                            </application-accommodation-consideration>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card v-if="item.applicantRole == 'residenceAssistant'" flat>
                            <!-- General Information -->
                            <ra-application-general-information :item="item"></ra-application-general-information>
                        </v-card>
                        <v-card v-else flat>
                            <!-- Placement Preference -->
                            <application-placement-preference :item="item"></application-placement-preference>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item v-if="item.hasOwnProperty('rulesOfResidence') && item.rulesOfResidence != ''">
                        <v-card flat>
                            <rules-of-residence :item="item"></rules-of-residence>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <!-- Residence Agreement Form -->
                            <!-- <application-residence-agreement-v1 :item="item"></application-residence-agreement-v1> -->
                            <application-residence-agreement-v2 :item="item"></application-residence-agreement-v2>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <!-- Payment Method -->
                            <application-payment-method :item="item"></application-payment-method>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import ApplicationAccommodationConsideration from './Application/AccommodationConsideration';
import ApplicationBuildingPreference from './Application/BuildingPreference';
import ApplicationEmergencyContactInformation from './Application/EmergencyContactInformation';
import ApplicationPaymentMethod from './Application/PaymentMethod';
import ApplicationPersonalInformation from './Application/PersonalInformation';
import ApplicationPlacementPreference from './Application/PlacementPreference';
//import ApplicationResidenceAgreementV1 from './Application/ResidenceAgreement/ResidenceAgreementV1';
import ApplicationResidenceAgreementV2 from './Application/ResidenceAgreement/ResidenceAgreementV2';
import RulesOfResidence from './Application/ResidenceAgreement/RulesOfResidence.vue';
import RaApplicationBuildingPreference from './Application/ResidenceAssistant/BuildingPreference';
import RaApplicationGeneralInformation from './Application/ResidenceAssistant/GeneralInformation';

export default {
    name: 'application-information',
    components: {
        ApplicationAccommodationConsideration,
        ApplicationBuildingPreference,
        ApplicationEmergencyContactInformation,
        ApplicationPaymentMethod,
        ApplicationPersonalInformation,
        ApplicationPlacementPreference,
        //ApplicationResidenceAgreementV1,
        ApplicationResidenceAgreementV2,
        RaApplicationBuildingPreference,
        RaApplicationGeneralInformation,
        RulesOfResidence
    },
    props: {
        dialog: {
            required: true,
            type: Boolean
        },
        item: {
            required: true,
            type: Object
        },
        user: {
            required: true
        }
    },
    data() {
        return {
            tab: null
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
            this.resetTab();
        },
        resetTab() {
            this.tab = null;
        }
    },
    computed: {
        kingsGreen() {
            return '#004236';
        },
        toolbarColor() {
            return '#FFA800';
        }
    }
}
</script>